export default {
    currentUser: {},
    users: [],
    customers: [],
    schedules: [],
    customersCopy: [],
    singleCustomer: {},
    contracts: [],
    contractsCopy: [],
    singleContract: {},
    invoice: [],
    invoiceCopy: [],
    invoiceFortnox: [],
    singleInvoice: {},
    billing: {},
    billingHistory: [],
    userSubscription: {},
    productArticles: [],
    productArticlesCopy: [],
    singleArticle: {},
    notificationAlert: [],
    notificationEvent: {
        data: [],
        total_resources: 0,
        total_pages: 1,
        page: 1,
        limit: 50,
    },
    singleNotificationEvent: {},
    singleAlertMessage: {},
    contractConfig: {},
    invoiceConfig: {},
    articleSegment: {
        results: [],
    },
    articleSegmentInfo: {},
    customerSegments: [],
    singleCustomerSegment: {},
    costCenter: [],
    currency: [],
    priceList: [],
    termOfDelivery: [],
    termOfPayment: [],
    wayOfDelivery: [],
    projects: [],
    units: [],
    accounts: [],
    printTemplates: [],
    notification: [],
    Tags: [],
    planDetails: [],
    subscriptionPackages: [],
    vatConstant: 1.12,
    currentCustomer: {},
    scheduleList: {results: []},
    contractFilter: {},
    customerFilter: {},
    invoiceFilter: {},
    scheduledFilter: {},
    articleFilter: {},
    recurringUpdateFilter: {},
};
